export default {
	text: "{changedBy} commented on this goal.",
};
